import { Box, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
  width: '100%',
}));

interface MainContentProps {
  sidebarOpen: boolean;
}

export const MainContent = styled(Box)<{ sidebarOpen?: boolean }>(({ theme, sidebarOpen = true }) => ({
    position: 'relative',
    right: 0,
    top: 0,
    width: '100%',
    padding: theme.spacing(3),
    transition: 'all 0.3s ease',
    backgroundColor: '#E7EFF5',
    minHeight: 'calc(100vh - 72px)',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    boxSizing: 'border-box',
    '& .MuiContainer-root': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  }));

export const TableSection = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  }));